module.exports = __webpack_public_path__ + "img/brood_mother_small.f079b27a.png";